import { IssueDetail } from "models/issue";
import { ResolutionInfo } from "models/resolutions";
import { ActionV2 } from "features/Resources/Shared/models";
import { fromActionPrefixId } from "features/Resources/Shared/helpers";
import { TimingIssueModalInputFields } from "./TimingResolution";

export function undeliveredResolutionIssueType(issue: IssueDetail) {
  return "Undelivered";
}

export function undeliveredResolution(_1: IssueDetail): ResolutionInfo {
  return ({
    issueType: "undelivered",
    tagText: "Undelivered",
    actionTitle: (action: ActionV2) => {
      const { resourceType } = fromActionPrefixId(action?.prefixId);
      return `This ${resourceType ?? "item"} was not delivered due to errors`;
    },
    title: "These were not delivered due to errors",
    additionalContext: "Items were scheduled to be sent/delivered, but we were unable to deliver them. Please review them, and skip, send or reschedule them.",
    inputComponent: TimingIssueModalInputFields,
  });
}
